<template lang="pug">
	div
		b-card-group(columns)
			lectureCard(v-for="(lecture,key) in myParticipant.lectures.data" :key="key" :_lecture="lecture" :title='lecture.title')

		NothingFound(v-if="!myParticipant.lectures.data.length")

		b-card-text
			b-button(variant='primary' @click="$bvModal.show('lectureModalAdd')") Добавить {{myParticipant.lectures.data.length ? 'еще один доклад' :'доклад'}}

		lectureModal(v-if="eventID" :eventID="eventID" :_userID="userID")

</template>

<script>
	import { mapState } from 'vuex'

	import lectureCard from '../components/cards/lectureCard'
	import lectureModal from '../../components/modals/lectureModal'

	export default {
		name: 'LecturesTab',
		components: {
			lectureCard,
			lectureModal,
		},
		data: () => ({

		}),
		computed: {
			...mapState(['myParticipant','account']),

			eventID(){ return this.myParticipant.data.event.id },
			userID(){ return this.account.data.id },
		},

	}
</script>
